import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var addAttendanceRes;
export const addAttendanceTodo = createAsyncThunk('addAttendance', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    // console.log(val)

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'course/add_attendence',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "training_id": val.training_id,
                "attend_user": val.attend_user,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return addAttendanceRes = res.data
    } catch (error) {
        return addAttendanceRes = error.response.data
    }
})